import React from 'react';
import PropTypes from 'prop-types';

import { Paragraph, Text } from '@zillow/constellation';
import BodySectionAnchor from '../BodySectionAnchor';
import BodySectionList from '../BodySectionList';

export default function BodySectionRichText({ richText }) {
  return (
    <Paragraph marginBottom="md">
      {richText.map((element, index) => {
        if (element.text) {
          return <Text key={index}>{element.text}</Text>;
        }

        if (element.bold) {
          return (
            <Text key={index}>
              <b>{element.bold}</b>
            </Text>
          );
        }

        if (element.anchor) {
          return <BodySectionAnchor key={index} anchor={element.anchor} />;
        }

        if (element.unorderedList) {
          return <BodySectionList key={index} list={element.unorderedList} />;
        }

        return null;
      })}
    </Paragraph>
  );
}

BodySectionRichText.propTypes = {
  richText: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      bold: PropTypes.string,
      anchor: PropTypes.shape({
        text: PropTypes.string.isRequired,
        href: PropTypes.string.isRequired,
      }),
      unorderedList: PropTypes.array,
    }),
  ).isRequired,
};
